import script from "./DropdownMenuAk.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./DropdownMenuAk.vue?vue&type=script&lang=js"
export * from "./DropdownMenuAk.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./DropdownMenuAk.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__